import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Spinner from '../../components/UI/Spinner/Spinner';
import queryString from 'query-string';

class RouterPage extends React.PureComponent {

    componentDidMount() {
        let values = queryString.parse(this.props.location.search)
		if(values.to !== undefined) {
            const to = values.to;
            delete values["to"];
            const queryString = Object.keys(values).map(key => key + '=' + values[key]).join('&');
            const url = `${to}?${queryString}`;
            if ( this.props.isAuthenticated ) {
                this.props.history.push( url );
            }
        }
    }

    render () {
        return (
            <div className="RouterPage">
                {
                    this.props.isAuthenticated ? <Spinner title="Redirecting..."></Spinner> : <Redirect to="/login"></Redirect>
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		expired: state.auth.expired
	};
};

const mapDispatchToProps = dispatch => {
	return {
        
	};
};

export default connect( mapStateToProps, mapDispatchToProps )(RouterPage);